import { c as _c } from "react/compiler-runtime";
import { ExportDropdown } from "@components/common/export/export-dropdown";
import { useDateTime } from "@hooks/use-date-time";
import { useMembers } from "@hooks/use-members";
import { creditTransactionsSelector, fetchingTransactionsFlagsSelector } from "@store/credit-transactions/credit-transactions-selector";
import { fetchedMembersFlagsSelector } from "@store/members/members-selector";
import { projectsSelector } from "@store/projects/projects-selector";
import { allCreditSubscriptionsSelector, selectedSdbCompanyNameSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { downloadPurchasesData, downloadTransactionsData } from "@utils/file-data-export";
import { TableType } from "@utils/track-event/track-event-list";
/** Dropdown to export the transactions or purchases in the file format selected by the user */
export function ExportTransactionsOrPurchases(t0) {
  const $ = _c(20);
  const {
    isTransactionsView
  } = t0;
  const {
    formatDate
  } = useDateTime();
  const companyName = useAppSelector(selectedSdbCompanyNameSelector);
  const {
    companyMembers
  } = useMembers();
  const transactions = useAppSelector(creditTransactionsSelector);
  const projects = useAppSelector(projectsSelector);
  const {
    status
  } = useAppSelector(fetchingTransactionsFlagsSelector);
  const {
    hasFetchedWorkspaceMembers
  } = useAppSelector(fetchedMembersFlagsSelector);
  const subscriptions = useAppSelector(allCreditSubscriptionsSelector);
  const isLoadingTransactions = isTransactionsView && (!hasFetchedWorkspaceMembers || status === "pending");
  let t1;
  if ($[0] !== companyMembers || $[1] !== companyName || $[2] !== formatDate || $[3] !== isTransactionsView || $[4] !== projects || $[5] !== subscriptions || $[6] !== transactions) {
    t1 = async function exportHandler(format) {
      if (isTransactionsView) {
        return await downloadTransactionsData({
          fileName: `${companyName}-Transactions List`,
          transactions,
          companyMembers,
          projects,
          formatDate,
          format
        });
      } else {
        return await downloadPurchasesData({
          subscriptions,
          fileName: `${companyName}-Purchases List`,
          formatDate,
          format
        });
      }
    };
    $[0] = companyMembers;
    $[1] = companyName;
    $[2] = formatDate;
    $[3] = isTransactionsView;
    $[4] = projects;
    $[5] = subscriptions;
    $[6] = transactions;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const exportHandler = t1;
  const t2 = isTransactionsView ? TableType.creditTransactions : TableType.creditPurchases;
  const t3 = isTransactionsView ? transactions.length : subscriptions.length;
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = {
      dataType: t2,
      numberOfEntities: t3,
      areEntitiesSelected: false
    };
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const t5 = `Successfully exported ${isTransactionsView ? "transactions" : "purchases"}.`;
  const t6 = `Couldn't export ${isTransactionsView ? "transactions" : "purchases"}. Please try again.`;
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = {
      success: t5,
      error: t6
    };
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = `Export ${isTransactionsView ? "transactions" : "purchases"}`;
  let t9;
  if ($[14] !== exportHandler || $[15] !== isLoadingTransactions || $[16] !== t4 || $[17] !== t7 || $[18] !== t8) {
    t9 = <ExportDropdown trackingProps={t4} exportHandler={exportHandler} toastMessage={t7} buttonTooltipText={t8} shouldShowSkeleton={isLoadingTransactions} buttonType="standard" />;
    $[14] = exportHandler;
    $[15] = isLoadingTransactions;
    $[16] = t4;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}